import React, { useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import close from "../../assets/close.svg";
import { motion, AnimatePresence } from "framer-motion";
import { interesse } from "../UnternehmensForm/kat";
import { useData } from "../../util/dataProvider";

export default function Page3({
    setPage,
    page,
    values,
    setFieldValue,
    errors,
    validateForm,
    touched,
}) {
    function validate(value) {
        let error;
        if (!value || value.length == 0) {
            error = "*Pflichtfeld";
        } else {
            error = null;
        }
        return error;
    }
    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }
    const { assetUrl, submitError } = useData();

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className='page2-form'>
                <Field
                    id='interested-'
                    name='interested'
                    type='text'
                    validate={validate}
                    style={{ height: 0, padding: 0, border: "none" }}
                />
                <label htmlFor='company-focus' className='label'>
                    Welche Interessen haben Sie?
                </label>

                <FieldArray
                    name='interested'
                    render={(arrayHelpers) => (
                        <div>
                            <div className='item-box-container'>
                                {values.interested &&
                                    values.interested.map((item, index) => {
                                        return (
                                            <div
                                                className='item'
                                                key={"selectitem2-" + index}
                                                onClick={() =>
                                                    arrayHelpers.remove(index)
                                                }>
                                                {item}{" "}
                                                <img src={assetUrl + close} />
                                            </div>
                                        );
                                    })}
                            </div>
                            {errors.interested && touched.interested && (
                                <div className='errors'>
                                    {errors.interested}
                                </div>
                            )}
                            <div className='item-box-item-list'>
                                {interesse.map((item, idx) => (
                                    <div
                                        key={`interesse-${idx}`}
                                        className='item'
                                        onClick={() =>
                                            arrayHelpers.push(item.value)
                                        }>
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}></FieldArray>

                <label htmlFor='company-other' className='label'>
                    Sonstige
                </label>
                <Field id='company-other' name='sontige2' type='text' />
                <label
                    className='small-text checktext'
                    style={{
                        display: "flex",
                        marginTop: "16px",
                    }}>
                    <Field type='checkbox' name='aggre' />
                    Sie willigen hiermit ein, dass Ihre hier angegebenen Daten
                    auf der bergisch.metall Website veröffentlicht werden.
                </label>
                <div
                    className='small-text checktext'
                    style={{
                        marginTop: "12px",
                    }}>
                    {" "}
                    Um sicher zu stellen, dass die teilnehmenden Unternehmen zu
                    unserem Verbund passen, wird Ihr Profil durch unser
                    bergisch.metall Team geprüft und erst danach veröffentlicht.
                    Sie erhalten eine Bestätigung, sobald dein Profil
                    erfolgreich erstellt wurde.
                </div>
                <div className='small-text' style={{ marginTop: "12px" }}>
                    Sollte es Probleme bei der Registrierung geben, dann
                    kontaktieren Sie uns bitte über folgende E-Mail-Adresse:{" "}
                    <a href='mailto:info@bergisch-metall.de'>
                        info@bergisch-metall.de
                    </a>
                </div>

                {submitError && (
                    <div
                        className='small-text checktext'
                        style={{
                            marginTop: "12px",
                            color: "#a72716",
                            alignSelf: "flex-end",
                        }}>
                        {submitError}
                    </div>
                )}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}>
                    <button
                        onClick={() => setPage(page - 1)}
                        className='button-red'
                        style={{ width: "300px" }}>
                        Zurück
                    </button>
                    <button
                        type='submit'
                        className='button-red'
                        style={{ width: "300px", alignSelf: "flex-end" }}>
                        Profil speichern
                    </button>
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
